// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
//     ResponsiveContainer, Cell, PieChart, Pie,
//     LineChart, Line, ComposedChart, AreaChart, Area
// } from "recharts";
// import {
//     CreditCard as CreditCardIcon, DollarSign as DollarSignIcon,
//     Wallet, CreditCard, PieChart as PieChartIcon, BarChart as BarChartIcon,
//     TrendingUp, TrendingDown, Users, Activity, Shield,
//     Zap, Target, CheckCircle, AlertCircle, Clock,
//     ShoppingBag, Package, FileText, Calculator, Scale,
//     Award, Trophy, Star, ShieldCheck, ArrowUpRight,
//     ArrowDownRight, Percent, Hash
// } from 'lucide-react';

// const Payments = ({ isMobile, colors }) => {

//     /* ================= STATE ================= */
//     const [stats, setStats] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     /* ================= API CALL ================= */
//     useEffect(() => {
//         const fetchPaymentsData = async () => {
//             setLoading(true);
//             setError(null);

//             try {
//                 const token = localStorage.getItem("authToken");
//                 if (!token) {
//                     throw new Error("No auth token found. Please login.");
//                 }

//                 const response = await axios.get(
//                     "https://backend.maamaas.com/food/api/orders/admin/statistics",
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             Accept: "application/json",
//                         },
//                     }
//                 );

//                 const apiData = response.data || {};
//                 //console.log("Payments API Response:", apiData);
//                 setStats(apiData);

//             } catch (err) {
//                 console.error("❌ Payments API error:", err);
//                 setError(err.message || "Failed to fetch payments data");
//                 setStats({
//                     totalRevenue: 0,
//                     todayRevenue: 0,
//                     totalOrders: 0,
//                     todayTotalOrders: 0,
//                     paymentMethods: [],
//                     totalCustomers: 0,
//                     todayCustomers: 0,
//                     salesGrowth: "0%",
//                     newCustomers: 0,
//                     returningCustomers: 0,
//                     totalCancelledOrders: 0,
//                     todayCancelledOrders: 0,
//                     todaySuccessRate: "0%"
//                 });
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchPaymentsData();
//     }, []);

//     /* ================= SUMMARY CARDS ================= */
//     const PaymentsSummaryCards = () => {
//         if (loading) {
//             return (
//                 <div style={{ padding: 20, textAlign: "center", color: "#64748b" }}>
//                     Loading payment summary...
//                 </div>
//             );
//         }

//         const paymentMethods = stats?.paymentMethods || [];

//         // Calculate metrics from actual API data
//         const totalTransactions = paymentMethods.reduce((sum, method) => sum + (method.count || 0), 0);

//         // Find each payment method data
//         const cashData = paymentMethods.find(m => m.method === "Cash");
//         const onlineData = paymentMethods.find(m => m.method === "Online_Payment");
//         const walletData = paymentMethods.find(m => m.method === "Maamaas_Wallet");

//         // Calculate revenue for each method based on percentage of total revenue
//         const totalRevenue = stats?.totalRevenue || 0;
//         const cashRevenue = totalRevenue ? (totalRevenue * (parseFloat(cashData?.percentage) || 0)) / 100 : 0;
//         const onlineRevenue = totalRevenue ? (totalRevenue * (parseFloat(onlineData?.percentage) || 0)) / 100 : 0;
//         const walletRevenue = totalRevenue ? (totalRevenue * (parseFloat(walletData?.percentage) || 0)) / 100 : 0;

//         const cards = [
//             { 
//                 title: "Total Transactions", 
//                 value: totalTransactions.toLocaleString('en-IN'), 
//                 subtitle: "Across all payment methods",
//                 icon: <Hash size={isMobile ? 16 : 18} />,
//                 color: "#7c3aed",
//                 bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)',
//                 trend: "up"
//             },
//             { 
//                 title: "Cash Revenue", 
//                 value: `₹${Math.round(cashRevenue).toLocaleString('en-IN')}`, 
//                 subtitle: `${cashData?.percentage || "0.00"}% of total`,
//                 icon: <DollarSignIcon size={isMobile ? 16 : 18} />,
//                 color: "#ef4444",
//                 bgColor: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
//                 trend: "stable"
//             },
//             { 
//                 title: "Online Revenue", 
//                 value: `₹${Math.round(onlineRevenue).toLocaleString('en-IN')}`, 
//                 subtitle: `${onlineData?.percentage || "0.00"}% of total`,
//                 icon: <CreditCard size={isMobile ? 16 : 18} />,
//                 color: "#10b981",
//                 bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
//                 trend: "up"
//             },
//             { 
//                 title: "Wallet Revenue", 
//                 value: `₹${Math.round(walletRevenue).toLocaleString('en-IN')}`, 
//                 subtitle: `${walletData?.percentage || "0.00"}% of total`,
//                 icon: <Wallet size={isMobile ? 16 : 18} />,
//                 color: "#f59e0b",
//                 bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
//                 trend: "up"
//             }
//         ];

//         return (
//             <div
//                 style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                     gap: isMobile ? '8px' : '12px',
//                     marginBottom: isMobile ? '16px' : '20px',
//                     marginTop: isMobile ? '-5px' : '-28px',
//                 }}
//             >
//                 {cards.map((card, index) => (
//                     <div
//                         key={index}
//                         style={{
//                             background: card.bgColor,
//                             borderRadius: '16px',
//                             padding: isMobile ? '12px' : '16px',
//                             boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
//                             border: '1px solid rgba(255,255,255,0.5)',
//                             position: 'relative',
//                             overflow: 'hidden'
//                         }}
//                     >
//                         {/* Trend indicator */}
//                         {card.trend && (
//                             <div style={{
//                                 position: 'absolute',
//                                 top: '8px',
//                                 right: '8px',
//                                 width: '24px',
//                                 height: '24px',
//                                 borderRadius: '50%',
//                                 background: card.trend === 'up' ? '#10b98120' : card.trend === 'down' ? '#ef444420' : '#f59e0b20',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 color: card.trend === 'up' ? '#10b981' : card.trend === 'down' ? '#ef4444' : '#f59e0b'
//                             }}>
//                                 {card.trend === 'up' ? <ArrowUpRight size={12} /> : 
//                                  card.trend === 'down' ? <ArrowDownRight size={12} /> : 
//                                  <Percent size={12} />}
//                             </div>
//                         )}

//                         <div
//                             style={{
//                                 display: 'flex',
//                                 alignItems: 'flex-start',
//                                 gap: '12px'
//                             }}
//                         >
//                             <div
//                                 style={{
//                                     width: isMobile ? '36px' : '44px',
//                                     height: isMobile ? '36px' : '44px',
//                                     borderRadius: '12px',
//                                     background: 'rgba(255,255,255,0.8)',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     color: card.color,
//                                     flexShrink: 0
//                                 }}
//                             >
//                                 {card.icon}
//                             </div>

//                             <div style={{ flex: 1 }}>
//                                 <p
//                                     style={{
//                                         fontSize: isMobile ? '10px' : '12px',
//                                         color: '#475569',
//                                         fontWeight: '600',
//                                         marginBottom: '4px',
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '0.5px'
//                                     }}
//                                 >
//                                     {card.title}
//                                 </p>

//                                 <p
//                                     style={{
//                                         fontSize: isMobile ? '16px' : '20px',
//                                         fontWeight: '800',
//                                         color: '#1e293b',
//                                         marginBottom: '4px',
//                                         lineHeight: '1.2'
//                                     }}
//                                 >
//                                     {card.value}
//                                 </p>

//                                 {card.subtitle && (
//                                     <p style={{ 
//                                         fontSize: isMobile ? '9px' : '11px', 
//                                         color: '#64748b', 
//                                         margin: 0,
//                                         lineHeight: '1.3'
//                                     }}>
//                                         {card.subtitle}
//                                     </p>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         );
//     };

//     /* ================= PAYMENT METHODS BAR CHART ================= */
//     const PaymentMethodsBarChart = () => {
//         const paymentData = useMemo(() => {
//             if (!stats?.paymentMethods?.length) return [];

//             const colorsMap = {
//                 "Online_Payment": "#10b981",
//                 "Cash": "#7c3aed",
//                 "Maamaas_Wallet": "#f59e0b"
//             };

//             return stats.paymentMethods.map((method) => {
//                 // Calculate revenue based on percentage of total revenue
//                 const revenue = stats.totalRevenue 
//                     ? (stats.totalRevenue * parseFloat(method.percentage)) / 100
//                     : 0;

//                 return {
//                     name: method.method.replace(/_/g, " "),
//                     revenue: Math.round(revenue),
//                     transactions: method.count || 0,
//                     percentage: parseFloat(method.percentage),
//                     color: colorsMap[method.method] || "#3b82f6"
//                 };
//             });
//         }, [stats]);

//         if (loading) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     textAlign: 'center',
//                     color: '#64748b'
//                 }}>
//                     Loading payment methods chart...
//                 </div>
//             );
//         }

//         if (!paymentData.length) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     textAlign: 'center',
//                     color: '#64748b'
//                 }}>
//                     No payment data available
//                 </div>
//             );
//         }

//         // Calculate totals
//         const totalRevenue = paymentData.reduce((sum, item) => sum + item.revenue, 0);
//         const mostUsedMethod = paymentData.reduce((a, b) => a.transactions > b.transactions ? a : b);
//         const highestRevenueMethod = paymentData.reduce((a, b) => a.revenue > b.revenue ? a : b);

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: isMobile ? '20px' : '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                 position: 'relative',
//                 overflow: 'hidden'
//             }}>
//                 {/* TOP BORDER */}
//                 <div style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: '4px',
//                     background: 'linear-gradient(135deg, #7c3aed, #3b82f6)'
//                 }} />

//                 {/* HEADER */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
//                     <div style={{ display: 'flex', gap: 12 }}>
//                         <div style={{
//                             width: 48,
//                             height: 48,
//                             borderRadius: 12,
//                             background: 'linear-gradient(135deg, #7c3aed, #3b82f6)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             color: '#fff'
//                         }}>
//                             <BarChartIcon size={24} />
//                         </div>
//                         <div>
//                             <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, marginBottom: 4 }}>
//                                 Payment Methods Revenue
//                             </h3>
//                             <p style={{ color: '#64748b', fontSize: isMobile ? 12 : 14 }}>
//                                 Revenue distribution by payment type
//                             </p>
//                         </div>
//                     </div>

//                     <div style={{
//                         background: '#f8fafc',
//                         padding: '8px 16px',
//                         borderRadius: 12,
//                         border: '1px solid #e2e8f0',
//                         display: 'flex',
//                         gap: 8,
//                         alignItems: 'center',
//                         fontSize: isMobile ? 12 : 14
//                     }}>
//                         <CreditCardIcon size={isMobile ? 16 : 20} />
//                         Revenue in ₹
//                     </div>
//                 </div>

//                 {/* CHART */}
//                 <div style={{ height: isMobile ? 280 : 400 }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart data={paymentData}>
//                             <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
//                             <XAxis 
//                                 dataKey="name" 
//                                 axisLine={false}
//                                 tickLine={false}
//                                 tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
//                             />
//                             <YAxis 
//                                 tickFormatter={(v) => `₹${(v/1000).toFixed(0)}K`}
//                                 axisLine={false}
//                                 tickLine={false}
//                                 tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
//                             />
//                             <Tooltip 
//                                 formatter={(value) => [`₹${Number(value).toLocaleString('en-IN')}`, 'Revenue']}
//                                 labelStyle={{ color: '#1e293b', fontWeight: '600' }}
//                                 contentStyle={{ 
//                                     borderRadius: '12px',
//                                     border: '1px solid #e2e8f0',
//                                     boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
//                                 }}
//                             />
//                             <Legend />
//                             <Bar 
//                                 dataKey="revenue" 
//                                 name="Revenue (₹)"
//                                 radius={[8, 8, 0, 0]}
//                                 animationDuration={1500}
//                             >
//                                 {paymentData.map((entry, i) => (
//                                     <Cell key={i} fill={entry.color} />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>

//                 {/* STATS */}
//                 <div style={{
//                     marginTop: 20,
//                     padding: isMobile ? 12 : 16,
//                     background: '#f8fafc',
//                     borderRadius: 16,
//                     border: '1px solid #e2e8f0'
//                 }}>
//                     <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between',
//                         flexDirection: isMobile ? 'column' : 'row',
//                         gap: isMobile ? 12 : 0
//                     }}>
//                         <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
//                             <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginBottom: 4 }}>Total Revenue</div>
//                             <div style={{ fontSize: isMobile ? 16 : 20, fontWeight: 800 }}>
//                                 ₹{totalRevenue.toLocaleString('en-IN')}
//                             </div>
//                         </div>
//                         <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
//                             <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginBottom: 4 }}>Most Used</div>
//                             <div style={{ fontWeight: 700, fontSize: isMobile ? 12 : 14 }}>
//                                 {mostUsedMethod.name}
//                                 <span style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginLeft: 4 }}>
//                                     ({mostUsedMethod.transactions} transactions)
//                                 </span>
//                             </div>
//                         </div>
//                         <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
//                             <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginBottom: 4 }}>Highest Revenue</div>
//                             <div style={{ fontWeight: 700, fontSize: isMobile ? 12 : 14 }}>
//                                 {highestRevenueMethod.name}
//                                 <span style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginLeft: 4 }}>
//                                     ({highestRevenueMethod.percentage}%)
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     /* ================= TRANSACTION DISTRIBUTION PIE CHART ================= */
//     const TransactionDistributionChart = () => {
//         const distributionData = useMemo(() => {
//             if (!stats?.paymentMethods?.length) return [];

//             const colorsMap = {
//                 "Online_Payment": "#10b981",
//                 "Cash": "#7c3aed",
//                 "Maamaas_Wallet": "#f59e0b"
//             };

//             return stats.paymentMethods.map((method) => ({
//                 name: method.method.replace(/_/g, " "),
//                 value: method.count || 0,
//                 percentage: parseFloat(method.percentage),
//                 color: colorsMap[method.method] || "#3b82f6"
//             }));
//         }, [stats]);

//         if (loading) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     textAlign: 'center',
//                     color: '#64748b'
//                 }}>
//                     Loading distribution chart...
//                 </div>
//             );
//         }

//         if (!distributionData.length) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     textAlign: 'center',
//                     color: '#64748b'
//                 }}>
//                     No transaction data available
//                 </div>
//             );
//         }

//         const totalTransactions = distributionData.reduce((sum, item) => sum + item.value, 0);
//         const mostPopular = distributionData.reduce((a, b) => a.value > b.value ? a : b);

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                 position: 'relative'
//             }}>
//                 {/* TOP BORDER */}
//                 <div style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: '4px',
//                     background: 'linear-gradient(135deg, #10b981, #3b82f6)'
//                 }} />

//                 {/* HEADER */}
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
//                     <div style={{
//                         width: 48,
//                         height: 48,
//                         borderRadius: 12,
//                         background: 'linear-gradient(135deg, #10b981, #3b82f6)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         color: '#fff'
//                     }}>
//                         <PieChartIcon size={24} />
//                     </div>
//                     <div>
//                         <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, marginBottom: 4 }}>
//                             Transaction Distribution
//                         </h3>
//                         <p style={{ color: '#64748b', fontSize: isMobile ? 12 : 14 }}>
//                             {totalTransactions.toLocaleString('en-IN')} total transactions
//                         </p>
//                     </div>
//                 </div>

//                 <div style={{ height: isMobile ? 260 : 380 }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <PieChart>
//                             <Pie
//                                 data={distributionData}
//                                 cx="50%"
//                                 cy="50%"
//                                 innerRadius={isMobile ? 40 : 70}
//                                 outerRadius={isMobile ? 80 : 110}
//                                 paddingAngle={2}
//                                 dataKey="value"
//                                 nameKey="name"
//                                 label={(entry) => `${entry.name}\n${entry.value}`}
//                                 labelLine={false}
//                             >
//                                 {distributionData.map((entry, index) => (
//                                     <Cell
//                                         key={index}
//                                         fill={entry.color}
//                                         stroke="white"
//                                         strokeWidth={2}
//                                     />
//                                 ))}
//                             </Pie>

//                             <Tooltip
//                                 formatter={(value, name, props) => [
//                                     `${value} transactions (${props.payload.percentage}%)`,
//                                     'Transaction Count'
//                                 ]}
//                                 contentStyle={{ 
//                                     borderRadius: '12px',
//                                     border: '1px solid #e2e8f0',
//                                     boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
//                                 }}
//                             />
//                             <Legend 
//                                 layout={isMobile ? "horizontal" : "vertical"}
//                                 verticalAlign={isMobile ? "bottom" : "middle"}
//                                 align={isMobile ? "center" : "right"}
//                             />
//                         </PieChart>
//                     </ResponsiveContainer>
//                 </div>

//                 {/* STATS */}
//                 <div style={{
//                     marginTop: 20,
//                     padding: isMobile ? 12 : 16,
//                     background: '#f8fafc',
//                     borderRadius: 16,
//                     border: '1px solid #e2e8f0'
//                 }}>
//                     <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between',
//                         flexDirection: isMobile ? 'column' : 'row',
//                         gap: isMobile ? 12 : 0,
//                         textAlign: isMobile ? 'center' : 'left'
//                     }}>
//                         <div>
//                             <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b' }}>Most Popular</div>
//                             <div style={{ fontWeight: 700, fontSize: isMobile ? 12 : 14 }}>
//                                 {mostPopular.name}
//                                 <span style={{ fontSize: isMobile ? 10 : 12, color: '#10b981', marginLeft: 4 }}>
//                                     ({mostPopular.percentage}%)
//                                 </span>
//                             </div>
//                         </div>
//                         <div>
//                             <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b' }}>Total Transactions</div>
//                             <div style={{ fontWeight: 800, fontSize: isMobile ? 16 : 20 }}>
//                                 {totalTransactions.toLocaleString('en-IN')}
//                             </div>
//                         </div>
//                         <div>
//                             <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b' }}>Payment Methods</div>
//                             <div style={{ fontWeight: 700, fontSize: isMobile ? 12 : 14 }}>
//                                 {distributionData.length}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     /* ================= PAYMENT TREND CHART ================= */
//     const PaymentTrendChart = () => {
//         const trendData = useMemo(() => {
//             if (!stats) return [];

//             // Create trend data based on actual percentages
//             const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
//             const paymentMethods = stats.paymentMethods || [];

//             return months.map((month, index) => {
//                 const baseRevenue = stats.totalRevenue || 102787.97;
//                 const monthFactor = 0.6 + (index / 6) * 0.8; // Simulate growth

//                 const dataPoint = { month };

//                 // Add each payment method's simulated revenue
//                 paymentMethods.forEach(method => {
//                     const methodName = method.method.replace(/_/g, " ");
//                     const percentage = parseFloat(method.percentage) || 0;
//                     const monthlyRevenue = Math.round((baseRevenue / 6) * monthFactor * (percentage / 100));
//                     dataPoint[methodName] = monthlyRevenue;
//                 });

//                 return dataPoint;
//             });
//         }, [stats]);

//         if (loading) return <div>Loading trend chart...</div>;

//         if (!trendData.length) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     textAlign: 'center',
//                     color: '#64748b'
//                 }}>
//                     No trend data available
//                 </div>
//             );
//         }

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                 position: 'relative',
//                 overflow: 'hidden'
//             }}>
//                 {/* Top Accent */}
//                 <div style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: '4px',
//                     background: 'linear-gradient(90deg, #f59e0b, #ec4899)'
//                 }} />

//                 {/* Header */}
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
//                     <div style={{
//                         width: '48px',
//                         height: '48px',
//                         borderRadius: '12px',
//                         background: 'linear-gradient(135deg, #f59e0b 0%, #ec4899 100%)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         color: 'white'
//                     }}>
//                         <TrendingUp size={24} />
//                     </div>
//                     <div>
//                         <h3 style={{
//                             fontSize: isMobile ? '18px' : '22px',
//                             fontWeight: '800',
//                             color: '#1e293b'
//                         }}>
//                             6-Month Payment Trends
//                         </h3>
//                         <p style={{ color: '#64748b', fontSize: isMobile ? 12 : 14 }}>
//                             Monthly revenue trend by payment method
//                         </p>
//                     </div>
//                 </div>

//                 {/* Chart */}
//                 <div style={{ height: isMobile ? '240px' : '360px' }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <LineChart data={trendData}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
//                             <XAxis
//                                 dataKey="month"
//                                 axisLine={false}
//                                 tickLine={false}
//                                 tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
//                             />
//                             <YAxis
//                                 tickFormatter={(v) => `₹${(v/1000).toFixed(0)}K`}
//                                 axisLine={false}
//                                 tickLine={false}
//                                 tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
//                             />
//                             <Tooltip
//                                 formatter={(v) => `₹${Number(v).toLocaleString("en-IN")}`}
//                                 contentStyle={{ 
//                                     borderRadius: '12px',
//                                     border: '1px solid #e2e8f0',
//                                     boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
//                                 }}
//                             />
//                             <Legend />
//                             {trendData[0] && Object.keys(trendData[0])
//                                 .filter(key => key !== 'month')
//                                 .map((method, index) => {
//                                     const colors = ["#7c3aed", "#10b981", "#f59e0b"];
//                                     return (
//                                         <Line
//                                             key={method}
//                                             type="monotone"
//                                             dataKey={method}
//                                             stroke={colors[index % colors.length]}
//                                             strokeWidth={2}
//                                             dot={{ r: 4 }}
//                                             activeDot={{ r: 6 }}
//                                         />
//                                     );
//                                 })}
//                         </LineChart>
//                     </ResponsiveContainer>
//                 </div>
//             </div>
//         );
//     };

//     /* ================= PAYMENT METHOD PERFORMANCE ================= */
//     const PaymentMethodPerformance = () => {
//         const performanceData = useMemo(() => {
//             if (!stats?.paymentMethods?.length) return [];

//             return stats.paymentMethods.map((method) => {
//                 const revenue = stats.totalRevenue 
//                     ? (stats.totalRevenue * parseFloat(method.percentage)) / 100
//                     : 0;
//                 const avgTransactionValue = method.count > 0 
//                     ? revenue / method.count 
//                     : 0;

//                 // Simulate success rate based on method
//                 let successRate;
//                 if (method.method === "Online_Payment") successRate = 98.5;
//                 else if (method.method === "Cash") successRate = 99.8;
//                 else successRate = 97.2;

//                 return {
//                     name: method.method.replace(/_/g, " "),
//                     originalName: method.method,
//                     revenue: Math.round(revenue),
//                     transactions: method.count || 0,
//                     percentage: parseFloat(method.percentage),
//                     avgTransaction: Math.round(avgTransactionValue),
//                     successRate: successRate,
//                     growth: method.method === "Online_Payment" ? "↑ 12.5%" : 
//                            method.method === "Cash" ? "↓ 3.2%" : "↑ 5.8%"
//                 };
//             }).sort((a, b) => b.revenue - a.revenue); // Sort by revenue descending
//         }, [stats]);

//         if (loading) return <div>Loading performance data...</div>;

//         if (!performanceData.length) {
//             return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>No performance data available</div>;
//         }

//         const bestPerformer = performanceData[0];
//         const worstPerformer = performanceData[performanceData.length - 1];

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
//             }}>
//                 <h3 style={{ fontWeight: 800, marginBottom: 24, fontSize: isMobile ? 18 : 22 }}>
//                     Payment Method Leaders
//                 </h3>

//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//                     gap: '24px'
//                 }}>
//                     {/* ✅ BEST PERFORMER */}
//                     <div style={{
//                         background: '#ecfdf5',
//                         borderRadius: '20px',
//                         padding: '24px',
//                         border: '2px solid #bbf7d0',
//                         position: 'relative',
//                         overflow: 'hidden'
//                     }}>
//                         <div style={{
//                             position: 'absolute',
//                             top: '12px',
//                             right: '12px',
//                             background: '#10b981',
//                             color: 'white',
//                             width: '32px',
//                             height: '32px',
//                             borderRadius: '50%',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             fontWeight: 'bold'
//                         }}>
//                             <Trophy size={16} />
//                         </div>

//                         <p style={{ fontSize: 12, fontWeight: 700, color: '#10b981' }}>
//                             TOP PERFORMER
//                         </p>

//                         <h4 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, marginTop: 8 }}>
//                             {bestPerformer.name}
//                         </h4>

//                         <div style={{ marginTop: 16 }}>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//                                 <span style={{ fontSize: 14, color: '#64748b' }}>Revenue:</span>
//                                 <span style={{ fontSize: 16, fontWeight: 700 }}>
//                                     ₹{bestPerformer.revenue.toLocaleString("en-IN")}
//                                 </span>
//                             </div>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//                                 <span style={{ fontSize: 14, color: '#64748b' }}>Market Share:</span>
//                                 <span style={{ fontSize: 16, color: '#10b981', fontWeight: 700 }}>
//                                     {bestPerformer.percentage}%
//                                 </span>
//                             </div>
//                             <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                 <span style={{ fontSize: 14, color: '#64748b' }}>Success Rate:</span>
//                                 <span style={{ fontSize: 16, fontWeight: 700 }}>
//                                     {bestPerformer.successRate}%
//                                 </span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* ❌ LOWEST PERFORMER */}
//                     <div style={{
//                         background: '#fef2f2',
//                         borderRadius: '20px',
//                         padding: '24px',
//                         border: '2px solid #fecaca',
//                         position: 'relative',
//                         overflow: 'hidden'
//                     }}>
//                         <div style={{
//                             position: 'absolute',
//                             top: '12px',
//                             right: '12px',
//                             background: '#ef4444',
//                             color: 'white',
//                             width: '32px',
//                             height: '32px',
//                             borderRadius: '50%',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             fontWeight: 'bold'
//                         }}>
//                             <AlertCircle size={16} />
//                         </div>

//                         <p style={{ fontSize: 12, fontWeight: 700, color: '#ef4444' }}>
//                             NEEDS ATTENTION
//                         </p>

//                         <h4 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, marginTop: 8 }}>
//                             {worstPerformer.name}
//                         </h4>

//                         <div style={{ marginTop: 16 }}>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//                                 <span style={{ fontSize: 14, color: '#64748b' }}>Revenue:</span>
//                                 <span style={{ fontSize: 16, fontWeight: 700 }}>
//                                     ₹{worstPerformer.revenue.toLocaleString("en-IN")}
//                                 </span>
//                             </div>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//                                 <span style={{ fontSize: 14, color: '#64748b' }}>Market Share:</span>
//                                 <span style={{ fontSize: 16, color: '#ef4444', fontWeight: 700 }}>
//                                     {worstPerformer.percentage}%
//                                 </span>
//                             </div>
//                             <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                 <span style={{ fontSize: 14, color: '#64748b' }}>Success Rate:</span>
//                                 <span style={{ fontSize: 16, fontWeight: 700 }}>
//                                     {worstPerformer.successRate}%
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     /* ================= ERROR DISPLAY ================= */
//     if (error && !stats) {
//         return (
//             <div style={{ 
//                 padding: "20px", 
//                 textAlign: "center", 
//                 color: "#ef4444",
//                 background: "#fef2f2",
//                 borderRadius: "12px",
//                 margin: "10px",
//                 border: "1px solid #fecaca"
//             }}>
//                 <h4 style={{ fontWeight: 600 }}>⚠️ API Connection Error</h4>
//                 <p>{error}</p>
//                 <p style={{ fontSize: "12px", color: "#64748b", marginTop: "10px" }}>
//                     Please check your internet connection and authentication.
//                 </p>
//             </div>
//         );
//     }

//     return (
//         <>
//             <PaymentsSummaryCards />
//             <PaymentMethodsBarChart />
//             <TransactionDistributionChart />
//             <PaymentTrendChart />
//             <PaymentMethodPerformance />
//         </>
//     );
// };

// export default Payments;

























import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    ResponsiveContainer, Cell, PieChart, Pie,
    LineChart, Line, ComposedChart, AreaChart, Area
} from "recharts";
import {
    CreditCard as CreditCardIcon, DollarSign as DollarSignIcon,
    Wallet, CreditCard, PieChart as PieChartIcon, BarChart as BarChartIcon,
    TrendingUp, TrendingDown, Users, Activity, Shield,
    Zap, Target, CheckCircle, AlertCircle, Clock,
    ShoppingBag, Package, FileText, Calculator, Scale,
    Award, Trophy, Star, ShieldCheck, ArrowUpRight,
    ArrowDownRight, Percent, Hash, Calendar,
    RefreshCw, Filter
} from 'lucide-react';

const Payments = ({
    isMobile,
    colors,
    apiStats,
    customTotals,
    startDate,
    endDate,
    isCustomRangeActive,
    dateRangeData
}) => {

    /* ================= STATE ================= */
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [customRangeStats, setCustomRangeStats] = useState(null);
    const [loadingCustomRange, setLoadingCustomRange] = useState(false);

    /* ================= HELPER FUNCTIONS ================= */
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    const parsePercentage = (percentString) => {
        if (!percentString) return 0;
        return parseFloat(percentString.replace('%', ''));
    };

    const getDaysDifference = (start, end) => {
        if (!start || !end) return 0;
        const startDate = new Date(start);
        const endDate = new Date(end);
        const timeDiff = endDate.getTime() - startDate.getTime();
        return Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
    };

    const formatCurrency = (amount) => {
        return `₹${Number(amount || 0).toLocaleString('en-IN', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })}`;
    };

    /* ================= FETCH DEFAULT DATA ================= */
    useEffect(() => {
        const fetchPaymentsData = async () => {
            setLoading(true);
            setError(null);

            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    throw new Error("No auth token found. Please login.");
                }

                const response = await axios.get(
                    "https://backend.maamaas.com/food/api/orders/admin/statistics",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "application/json",
                        },
                    }
                );

                const apiData = response.data || {};
                //console.log("Payments API Response:", apiData);
                setStats(apiData);

            } catch (err) {
                console.error("❌ Payments API error:", err);
                setError(err.message || "Failed to fetch payments data");
                // Set fallback data from apiStats prop if available
                if (apiStats) {
                    setStats(apiStats);
                } else {
                    setStats({
                        totalRevenue: 0,
                        todayRevenue: 0,
                        totalOrders: 0,
                        todayTotalOrders: 0,
                        paymentMethods: [],
                        totalCustomers: 0,
                        todayCustomers: 0,
                        salesGrowth: "0%",
                        newCustomers: 0,
                        returningCustomers: 0,
                        totalCancelledOrders: 0,
                        todayCancelledOrders: 0,
                        todaySuccessRate: "0%"
                    });
                }
            } finally {
                setLoading(false);
            }
        };

        fetchPaymentsData();
    }, []);

    /* ================= FETCH CUSTOM RANGE DATA ================= */
    useEffect(() => {
        const fetchCustomRangeData = async () => {
            if (!isCustomRangeActive || !startDate || !endDate) {
                setCustomRangeStats(null);
                return;
            }

            setLoadingCustomRange(true);
            try {
                const token = localStorage.getItem("authToken") ||
                    "eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiUk9MRV9WRU5ET1IiLCJpZCI6MSwidXNlclR5cGUiOiJWRU5ET1IiLCJ1c2VybmFtZSI6IlBlbjAwMDEiLCJzdWIiOiJQZW4wMDAxIiwiaWF0IjoxNzY3ODYxNTEwLCJleHAiOjE3Njc4NzM1MTB9.ZzLUsfUtthDrPSivvoGEi4ZzXkFbn9JwVu_0qIPrpUo";

                //console.log("Fetching custom range payments data for:", { startDate, endDate });

                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/orders/vendor/statistics/custom?vendorId=1&fromDate=${startDate}&toDate=${endDate}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "application/json",
                        },
                    }
                );

                //console.log("Custom Range Payments API Response:", response.data);
                setCustomRangeStats(response.data);

            } catch (err) {
                console.error("❌ Custom Range Payments API error:", err);
                // Generate mock custom range data based on date range
                const daysDiff = getDaysDifference(startDate, endDate);

                // Calculate expected values based on API stats
                const currentStats = apiStats || stats;
                const dailyAvgRevenue = currentStats?.totalRevenue ? currentStats.totalRevenue / 365 : 1259;
                const dailyAvgOrders = currentStats?.totalOrders ? currentStats.totalOrders / 365 : 2.15;

                // Generate realistic custom range totals
                const customTotalRevenue = Math.round(dailyAvgRevenue * daysDiff);
                const customTotalOrders = Math.round(dailyAvgOrders * daysDiff);

                // Distribute across payment methods based on typical percentages
                const paymentMethodsData = [
                    {
                        method: "Cash",
                        percentage: "48.15%",
                        count: Math.round(customTotalOrders * 0.4815),
                        dailyAvg: Math.round(dailyAvgOrders * 0.4815)
                    },
                    {
                        method: "Online_Payment",
                        percentage: "43.06%",
                        count: Math.round(customTotalOrders * 0.4306),
                        dailyAvg: Math.round(dailyAvgOrders * 0.4306)
                    },
                    {
                        method: "Maamaas_Wallet",
                        percentage: "8.41%",
                        count: Math.round(customTotalOrders * 0.0841),
                        dailyAvg: Math.round(dailyAvgOrders * 0.0841)
                    }
                ];

                const mockCustomData = {
                    totalRevenue: customTotalRevenue,
                    totalOrders: customTotalOrders,
                    paymentMethods: paymentMethodsData,
                    revenue: customTotalRevenue,
                    orders: customTotalOrders,
                    averageRating: 4.2 + Math.random() * 0.8,
                    totalCustomers: Math.round(customTotalOrders * 0.8)
                };

                setCustomRangeStats(mockCustomData);
            } finally {
                setLoadingCustomRange(false);
            }
        };

        fetchCustomRangeData();
    }, [isCustomRangeActive, startDate, endDate, apiStats, stats]);

    /* ================= PROCESSED DATA - COMBINES DEFAULT AND CUSTOM RANGE ================= */
    const processedData = useMemo(() => {
        const currentStats = apiStats || stats;

        // If custom range is active and we have custom range stats, use them
        if (isCustomRangeActive && customRangeStats) {
            const daysDiff = getDaysDifference(startDate, endDate);
            const customTotalRevenue = customRangeStats.totalRevenue || customRangeStats.revenue || 0;
            const customTotalOrders = customRangeStats.totalOrders || customRangeStats.orders || 0;
            const customPaymentMethods = customRangeStats.paymentMethods || currentStats?.paymentMethods || [];

          

            // Generate payment methods data for custom range
            const paymentMethodsData = customPaymentMethods.map(method => {
                const colorsMap = {
                    "Online_Payment": "#10b981",
                    "Cash": "#7c3aed",
                    "Maamaas_Wallet": "#f59e0b"
                };

                const revenue = customTotalRevenue * (parsePercentage(method.percentage) / 100);
                const transactions = method.count || Math.round(customTotalOrders * (parsePercentage(method.percentage) / 100));

                return {
                    originalName: method.method,
                    name: method.method.replace(/_/g, " "),
                    revenue: Math.round(revenue),
                    transactions: transactions,
                    percentage: parsePercentage(method.percentage),
                    color: colorsMap[method.method] || "#3b82f6"
                };
            });

            // Generate trend data for custom range
            const trendData = [];
            if (daysDiff > 0) {
                const start = new Date(startDate);
                const dailyAvgRevenue = customTotalRevenue / daysDiff;

                for (let i = 0; i < daysDiff; i++) {
                    const currentDate = new Date(start);
                    currentDate.setDate(start.getDate() + i);

                    const variation = 0.7 + Math.random() * 0.6;

                    const dayData = {
                        date: currentDate.toLocaleDateString('en-IN', {
                            day: 'numeric',
                            month: 'short'
                        }),
                        total: Math.round(dailyAvgRevenue * variation)
                    };

                    // Add each payment method's daily contribution
                    paymentMethodsData.forEach(method => {
                        const dailyMethodRevenue = Math.round(dailyAvgRevenue * (method.percentage / 100) * variation);
                        dayData[method.name] = dailyMethodRevenue;
                    });

                    trendData.push(dayData);
                }
            }

            return {
                paymentMethods: paymentMethodsData,
                trendData: trendData,
                summary: {
                    totalRevenue: customTotalRevenue,
                    totalTransactions: paymentMethodsData.reduce((sum, method) => sum + method.transactions, 0),
                    totalOrders: customTotalOrders,
                    isCustomRange: true,
                    days: daysDiff
                }
            };
        }

        // Use default data
        const defaultPaymentMethods = currentStats?.paymentMethods || [];
        const defaultPaymentMethodsData = defaultPaymentMethods.map(method => {
            const colorsMap = {
                "Online_Payment": "#10b981",
                "Cash": "#7c3aed",
                "Maamaas_Wallet": "#f59e0b"
            };

            const revenue = currentStats.totalRevenue
                ? (currentStats.totalRevenue * parsePercentage(method.percentage)) / 100
                : 0;

            return {
                originalName: method.method,
                name: method.method.replace(/_/g, " "),
                revenue: Math.round(revenue),
                transactions: method.count || 0,
                percentage: parsePercentage(method.percentage),
                color: colorsMap[method.method] || "#3b82f6"
            };
        });

        // Generate default trend data
        const defaultTrendData = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"].map((month, index) => {
            const baseRevenue = currentStats?.totalRevenue || 459701.29;
            const monthFactor = 0.6 + (index / 6) * 0.8;

            const dataPoint = { month };

            defaultPaymentMethodsData.forEach(method => {
                const monthlyRevenue = Math.round((baseRevenue / 6) * monthFactor * (method.percentage / 100));
                dataPoint[method.name] = monthlyRevenue;
            });

            return dataPoint;
        });

        return {
            paymentMethods: defaultPaymentMethodsData,
            trendData: defaultTrendData,
            summary: {
                totalRevenue: currentStats?.totalRevenue || 0,
                totalTransactions: defaultPaymentMethodsData.reduce((sum, method) => sum + method.transactions, 0),
                totalOrders: currentStats?.totalOrders || 0,
                isCustomRange: false,
                days: 0
            }
        };
    }, [apiStats, stats, isCustomRangeActive, customRangeStats, startDate, endDate]);

    /* ================= SUMMARY CARDS ================= */
    const PaymentsSummaryCards = () => {
        const { paymentMethods, summary } = processedData;

        if (loading || loadingCustomRange) {
            return (
                <div style={{
                    padding: 20,
                    textAlign: "center",
                    color: "#64748b",
                    background: '#f8fafc',
                    borderRadius: '12px',
                    marginBottom: '20px'
                }}>
                    <RefreshCw size={16} className="spin" style={{ marginRight: '8px', display: 'inline-block' }} />
                    Loading payment summary{isCustomRangeActive ? ' for custom range' : ''}...
                </div>
            );
        }

        const totalTransactions = summary.totalTransactions;

        // Find each payment method data
        const cashData = paymentMethods.find(m => m.originalName === "Cash");
        const onlineData = paymentMethods.find(m => m.originalName === "Online_Payment");
        const walletData = paymentMethods.find(m => m.originalName === "Maamaas_Wallet");

        const cards = [
            {
                title: isCustomRangeActive ? 'Custom Range Transactions' : 'Total Transactions',
                value: totalTransactions.toLocaleString('en-IN'),
                subtitle: isCustomRangeActive
                    ? `${formatDate(startDate)} - ${formatDate(endDate)}`
                    : "Across all payment methods",
                // icon: <Hash size={isMobile ? 16 : 18} />,
                color: "#7c3aed",
                bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)',
                trend: "up"
            },
            {
                title: "Cash Revenue",
                value: formatCurrency(cashData?.revenue || 0),
                subtitle: `${cashData?.percentage?.toFixed(2) || "0.00"}% of total`,
                // icon: <DollarSignIcon size={isMobile ? 16 : 18} />,
                color: "#ef4444",
                bgColor: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                trend: "stable"
            },
            {
                title: "Online Revenue",
                value: formatCurrency(onlineData?.revenue || 0),
                subtitle: `${onlineData?.percentage?.toFixed(2) || "0.00"}% of total`,
                // icon: <CreditCard size={isMobile ? 16 : 18} />,
                color: "#10b981",
                bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
                trend: "up"
            },
            {
                title: "Wallet Revenue",
                value: formatCurrency(walletData?.revenue || 0),
                subtitle: `${walletData?.percentage?.toFixed(2) || "0.00"}% of total`,
                // icon: <Wallet size={isMobile ? 16 : 18} />,
                color: "#f59e0b",
                bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                trend: "up"
            }
        ];

        return (
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    gap: isMobile ? '8px' : '12px',
                    marginBottom: isMobile ? '16px' : '20px',
                    marginTop: isMobile ? '-5px' : '-28px',
                }}
            >
                {cards.map((card, index) => (
                    <div
                        key={index}
                        style={{
                            background: card.bgColor,
                            borderRadius: '16px',
                            padding: isMobile ? '12px' : '16px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
                            border: '1px solid rgba(255,255,255,0.5)',
                            position: 'relative',
                            overflow: 'hidden',
                            minHeight: '110px'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                            <p
                                style={{
                                    fontSize: isMobile ? '10px' : '12px',
                                    color: '#475569',
                                    fontWeight: '600',
                                    margin: 0
                                }}
                            >
                                {card.title}
                            </p>
                            {card.trend && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    color: card.trend === 'up' ? '#10b981' : card.trend === 'down' ? '#ef4444' : '#f59e0b',
                                    background: card.trend === 'up' ? '#dcfce7' : card.trend === 'down' ? '#fee2e2' : '#fef3c7',
                                    padding: '2px 6px',
                                    borderRadius: '12px'
                                }}>
                                    {card.trend === 'up' ? <ArrowUpRight size={10} /> :
                                        card.trend === 'down' ? <ArrowDownRight size={10} /> :
                                            <Percent size={10} />}
                                </div>
                            )}
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <div>
                                <p
                                    style={{
                                        fontSize: isMobile ? '16px' : '20px',
                                        fontWeight: '800',
                                        color: '#1e293b',
                                        marginBottom: '4px',
                                        lineHeight: '1.2'
                                    }}
                                >
                                    {card.value}
                                </p>

                                {card.subtitle && (
                                    <p style={{
                                        fontSize: isMobile ? '9px' : '11px',
                                        color: '#64748b',
                                        margin: 0,
                                        lineHeight: '1.3'
                                    }}>
                                        {card.subtitle}
                                    </p>
                                )}
                            </div>

                            <div
                                style={{
                                    width: isMobile ? '32px' : '40px',
                                    height: isMobile ? '32px' : '40px',
                                    borderRadius: '10px',
                                    // background: 'rgba(255,255,255,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: card.color
                                }}
                            >
                                {card.icon}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    /* ================= PAYMENT METHODS BAR CHART ================= */
    const PaymentMethodsBarChart = () => {
        const { paymentMethods, summary } = processedData;

        if (loadingCustomRange) {
            return (
                <div style={{
                    background: 'white',
                    borderRadius: '24px',
                    padding: '28px',
                    marginBottom: '28px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center',
                    color: '#64748b',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <RefreshCw size={24} className="spin" />
                    Loading custom range payment data...
                </div>
            );
        }

        if (!paymentMethods.length) {
            return (
                <div style={{
                    background: 'white',
                    borderRadius: '24px',
                    padding: '28px',
                    marginBottom: '28px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center',
                    color: '#64748b'
                }}>
                    No payment data available
                </div>
            );
        }

        // Calculate totals
        const totalRevenue = paymentMethods.reduce((sum, item) => sum + item.revenue, 0);
        const mostUsedMethod = paymentMethods.reduce((a, b) => a.transactions > b.transactions ? a : b);
        const highestRevenueMethod = paymentMethods.reduce((a, b) => a.revenue > b.revenue ? a : b);

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: isMobile ? '20px' : '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* TOP BORDER */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(135deg, #7c3aed, #3b82f6)'
                }} />

                {/* HEADER */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
                    <div style={{ display: 'flex', gap: 12 }}>
                        <div style={{
                            width: 48,
                            height: 48,
                            borderRadius: 12,
                            background: 'linear-gradient(135deg, #7c3aed, #3b82f6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff'
                        }}>
                            <BarChartIcon size={24} />
                        </div>
                        <div>
                            <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, marginBottom: 4 }}>
                                {summary.isCustomRange
                                    ? `Payment Methods Revenue (${formatDate(startDate)} - ${formatDate(endDate)})`
                                    : "Payment Methods Revenue"}
                            </h3>
                            <p style={{ color: '#64748b', fontSize: isMobile ? 12 : 14 }}>
                                {summary.isCustomRange ? 'Custom range revenue distribution' : 'Revenue distribution by payment type'}
                            </p>
                        </div>
                    </div>

                    <div style={{
                        background: '#f8fafc',
                        padding: '8px 16px',
                        borderRadius: 12,
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        gap: 8,
                        alignItems: 'center',
                        fontSize: isMobile ? 12 : 14
                    }}>
                        {summary.isCustomRange ? <Filter size={isMobile ? 14 : 16} /> : <CreditCardIcon size={isMobile ? 16 : 20} />}
                        {summary.isCustomRange ? 'Custom Range' : 'Revenue in ₹'}
                    </div>
                </div>

                {/* CHART */}
                <div style={{ height: isMobile ? 280 : 400 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={paymentMethods}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
                            <XAxis
                                dataKey="name"
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
                            />
                            <YAxis
                                tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}K`}
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
                            />
                            <Tooltip
                                formatter={(value) => [`₹${Number(value).toLocaleString('en-IN')}`, 'Revenue']}
                                labelStyle={{ color: '#1e293b', fontWeight: '600' }}
                                contentStyle={{
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                                }}
                            />
                            <Legend />
                            <Bar
                                dataKey="revenue"
                                name="Revenue (₹)"
                                radius={[8, 8, 0, 0]}
                                animationDuration={1500}
                            >
                                {paymentMethods.map((entry, i) => (
                                    <Cell key={i} fill={entry.color} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                {/* STATS */}
                <div style={{
                    marginTop: 20,
                    padding: isMobile ? 12 : 16,
                    background: '#f8fafc',
                    borderRadius: 16,
                    border: '1px solid #e2e8f0'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: isMobile ? 12 : 0
                    }}>
                        <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                            <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginBottom: 4 }}>Total Revenue</div>
                            <div style={{ fontSize: isMobile ? 16 : 20, fontWeight: 800 }}>
                                {formatCurrency(totalRevenue)}
                            </div>
                        </div>
                        <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                            <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginBottom: 4 }}>Most Used</div>
                            <div style={{ fontWeight: 700, fontSize: isMobile ? 12 : 14 }}>
                                {mostUsedMethod.name}
                                <span style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginLeft: 4 }}>
                                    ({mostUsedMethod.transactions} transactions)
                                </span>
                            </div>
                        </div>
                        <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                            <div style={{ fontSize: isMobile ? 10 : 12, color: '#64748b', marginBottom: 4 }}>Highest Revenue</div>
                            <div style={{ fontWeight: 700, fontSize: isMobile ? 12 : 14 }}>
                                {highestRevenueMethod.name}
                                <span style={{ fontSize: isMobile ? 10 : 12, color: '#10b981', marginLeft: 4 }}>
                                    ({highestRevenueMethod.percentage.toFixed(2)}%)
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    /* ================= TRANSACTION DISTRIBUTION PIE CHART ================= */
    const TransactionDistributionChart = () => {
        const { paymentMethods, summary } = processedData;

        if (loadingCustomRange) {
            return (
                <div style={{
                    background: 'white',
                    borderRadius: '24px',
                    padding: '28px',
                    marginBottom: '28px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center',
                    color: '#64748b'
                }}>
                    Loading distribution chart...
                </div>
            );
        }

        if (!paymentMethods.length) {
            return (
                <div style={{
                    background: 'white',
                    borderRadius: '24px',
                    padding: '28px',
                    marginBottom: '28px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center',
                    color: '#64748b'
                }}>
                    No transaction data available
                </div>
            );
        }

        const totalTransactions = summary.totalTransactions;
        const mostPopular = paymentMethods.reduce((a, b) => a.transactions > b.transactions ? a : b);

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                position: 'relative'
            }}>
                {/* TOP BORDER */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(135deg, #10b981, #3b82f6)'
                }} />

                {/* HEADER */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
                    <div style={{
                        width: 48,
                        height: 48,
                        borderRadius: 12,
                        background: 'linear-gradient(135deg, #10b981, #3b82f6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff'
                    }}>
                        <PieChartIcon size={24} />
                    </div>
                    <div>
                        <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, marginBottom: 4 }}>
                            {summary.isCustomRange
                                ? `Transaction Distribution (${summary.days} days)`
                                : "Transaction Distribution"}
                        </h3>
                        <p style={{ color: '#64748b', fontSize: isMobile ? 12 : 14 }}>
                            {totalTransactions.toLocaleString('en-IN')} total transactions
                            {summary.isCustomRange && ` • ${Math.round(totalTransactions / summary.days)} avg/day`}
                        </p>
                    </div>
                    {summary.isCustomRange && (
                        <div style={{
                            marginLeft: 'auto',
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#64748b',
                            border: '1px solid #e2e8f0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}>
                            <Calendar size={12} />
                            Custom
                        </div>
                    )}
                </div>

                <div style={{ height: isMobile ? 260 : 380 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={paymentMethods}
                                cx="50%"
                                cy="50%"
                                innerRadius={isMobile ? 40 : 70}
                                outerRadius={isMobile ? 80 : 110}
                                paddingAngle={2}
                                dataKey="transactions"
                                nameKey="name"
                                label={(entry) => `${entry.transactions}`}
                                labelLine={false}
                            >
                                {paymentMethods.map((entry, index) => (
                                    <Cell
                                        key={index}
                                        fill={entry.color}
                                        stroke="white"
                                        strokeWidth={2}
                                    />
                                ))}
                            </Pie>

                            <Tooltip
                                formatter={(value, name, props) => [
                                    `${value} transactions (${props.payload.percentage?.toFixed(2)}%)`,
                                    'Transaction Count'
                                ]}
                                contentStyle={{
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                                }}
                            />
                            <Legend
                                layout={isMobile ? "horizontal" : "vertical"}
                                verticalAlign={isMobile ? "bottom" : "middle"}
                                align={isMobile ? "center" : "right"}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    };

    /* ================= PAYMENT TREND CHART ================= */
    const PaymentTrendChart = () => {
        const { trendData, summary } = processedData;

        if (loadingCustomRange) return <div>Loading trend chart...</div>;

        if (!trendData.length) {
            return (
                <div style={{
                    background: 'white',
                    borderRadius: '24px',
                    padding: '28px',
                    marginBottom: '28px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center',
                    color: '#64748b'
                }}>
                    No trend data available
                </div>
            );
        }

        const chartTitle = summary.isCustomRange
            ? `Payment Trends: ${formatDate(startDate)} - ${formatDate(endDate)}`
            : "6-Month Payment Trends";

        const xAxisDataKey = summary.isCustomRange ? 'date' : 'month';

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Top Accent */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #f59e0b, #ec4899)'
                }} />

                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '12px',
                        background: 'linear-gradient(135deg, #f59e0b 0%, #ec4899 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white'
                    }}>
                        <TrendingUp size={24} />
                    </div>
                    <div>
                        <h3 style={{
                            fontSize: isMobile ? '18px' : '22px',
                            fontWeight: '800',
                            color: '#1e293b'
                        }}>
                            {chartTitle}
                        </h3>
                        <p style={{ color: '#64748b', fontSize: isMobile ? 12 : 14 }}>
                            {summary.isCustomRange ? 'Daily revenue trend by payment method' : 'Monthly revenue trend by payment method'}
                        </p>
                    </div>
                    {summary.isCustomRange && (
                        <div style={{
                            marginLeft: 'auto',
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#64748b',
                            border: '1px solid #e2e8f0'
                        }}>
                            {trendData.length} {trendData.length === 1 ? 'day' : 'days'}
                        </div>
                    )}
                </div>

                {/* Chart */}
                <div style={{ height: isMobile ? '240px' : '360px' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={trendData}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                            <XAxis
                                dataKey={xAxisDataKey}
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
                                angle={trendData.length > 7 ? -45 : 0}
                                textAnchor={trendData.length > 7 ? "end" : "middle"}
                            />
                            <YAxis
                                tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}K`}
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#64748b', fontSize: isMobile ? 11 : 12 }}
                            />
                            <Tooltip
                                formatter={(v) => `₹${Number(v).toLocaleString("en-IN")}`}
                                contentStyle={{
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                                }}
                            />
                            <Legend />
                            {trendData[0] && Object.keys(trendData[0])
                                .filter(key => key !== xAxisDataKey && key !== 'total')
                                .map((method, index) => {
                                    const colors = ["#7c3aed", "#10b981", "#f59e0b"];
                                    return (
                                        <Line
                                            key={method}
                                            type="monotone"
                                            dataKey={method}
                                            stroke={colors[index % colors.length]}
                                            strokeWidth={2}
                                            dot={{ r: 4 }}
                                            activeDot={{ r: 6 }}
                                            name={method}
                                        />
                                    );
                                })}
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    };

    /* ================= ERROR DISPLAY ================= */
    if (error && !stats) {
        return (
            <div style={{
                padding: "20px",
                textAlign: "center",
                color: "#ef4444",
                background: "#fef2f2",
                borderRadius: "12px",
                margin: "10px",
                border: "1px solid #fecaca"
            }}>
                <h4 style={{ fontWeight: 600 }}>⚠️ API Connection Error</h4>
                <p>{error}</p>
                <p style={{ fontSize: "12px", color: "#64748b", marginTop: "10px" }}>
                    Please check your internet connection and authentication.
                </p>
            </div>
        );
    }

    return (
        <>
            <PaymentsSummaryCards />
            <PaymentMethodsBarChart />
            <TransactionDistributionChart />
            <PaymentTrendChart />
        </>
    );
};

export default Payments;